module.exports = __webpack_public_path__ + "img/jppdimg_mo2.d67238ca.png";